'use client';

import { cn } from '@core/utils';
import type { SliderProps as RadixSliderProps } from '@radix-ui/react-slider';
import * as RadixSlider from '@radix-ui/react-slider';

interface SliderProps extends RadixSliderProps {
  min: number;
  max: number;
  value: number[];
  range: number;
  className?: string;
}

export const Slider = ({
  className,
  value,
  min,
  max,
  range,
  ...props
}: SliderProps) => {
  const extendedRange = range * 1.1;
  const left = `${Math.max(0, ((value[0] - extendedRange - min) / (max - min)) * 100).toFixed(5)}%`;
  const right = `${Math.max(0, 100 - ((value[0] + extendedRange - min) / (max - min)) * 100).toFixed(5)}%`;

  return (
    <RadixSlider.Root
      max={max}
      min={min}
      value={value}
      {...props}
      className={cn(
        'relative flex h-6 touch-none select-none items-center bg-Gray-300',
        className,
      )}
    >
      <RadixSlider.Track className="relative h-6 grow cursor-pointer">
        <div className="relative h-full">
          <div
            className="absolute h-full"
            style={{
              left,
              right,
              background: `linear-gradient(
                to right, 
                rgba(73, 176, 255, 0) 0%, 
                rgba(73, 176, 255, 1) 15%, 
                rgba(73, 176, 255, 1) 85%, 
                rgba(73, 176, 255, 0) 100%
              )`,
            }}
          />
          <RadixSlider.Range className="absolute rounded-pill" />
        </div>
      </RadixSlider.Track>
      <RadixSlider.Thumb
        className={cn(
          'block size-20 rounded-pill border-4 border-B-300 bg-Gray-white',
          'transition-transform duration-200 ease-in-out',
          'focus:shadow-none focus:outline-none focus:ring-0',
          'cursor-pointer hover:scale-125 active:scale-95',
        )}
      />
    </RadixSlider.Root>
  );
};
